// import React from "react";
// import { InputSwitch } from "primereact/inputswitch";

// const SwitchInput = ({ label, value, handleChange, ...rest }) => {
//   return (
//     <div>
//       <label className="text-base block font-medium mb-2">{label}</label>
//       <InputSwitch
//         checked={value}
//         onChange={handleChange}
//         {...rest}
//         pt={{ slider: { className: `${value ? "bg-primary" : ""}` } }}
//       />
//     </div>
//   );
// };

// export default SwitchInput;
import React from "react";
import { InputSwitch } from "primereact/inputswitch";

const SwitchInput = ({
  parentClass = "",
  label,
  value,
  handleChange,
  labelClassName,
  ...rest
}) => {
  return (
    <div className={`flex flex-col gap-1 w-full mb-2 ${parentClass}`}>
      {label && (
        <label className={labelClassName ? labelClassName : "input-label"}>
          {label}
        </label>
      )}
      <InputSwitch
        checked={value}
        onChange={handleChange}
        {...rest}
        pt={{
          root: { className: "!h-[20px]" },
          slider: {
            className: `rounded-[100px] ${value ? "!bg-primary" : ""}`,
          },
        }}
      />
    </div>
  );
};

export default SwitchInput;
